<template>
  <div class="container" id="t1content">
    <a-layout-content>
      <T1Breadcrumbs class="mb-16" :homeLink="true" :items="getBreadcrumbs()" />

      <div class="content-pane content-pane_white confirm-box">
        <div class="confirm-box__content">
          <div class="mb-24">
            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="60.89">
              <path
                fill="#5ebb1d"
                d="M64 30.43l-7.1-8.09 1-10.7-10.51-2.39L41.89 0 32 4.25 22.1 0l-5.49 9.25-10.5 2.36.99 10.7L0 30.43l7.1 8.09-1 10.73 10.51 2.39 5.5 9.25L32 56.6l9.9 4.25 5.49-9.25 10.5-2.39-.99-10.7 7.1-8.1M26.18 44.98L14.55 33.34l4.1-4.1 7.53 7.5 19.17-19.17 4.1 4.13z"
              />
            </svg>
          </div>
          <p class="font-22">
            Numer zamówienia:<br />
            <span class="font-m">{{ numerzamowienia }}</span>
          </p>
          <p class="mb-32">
            Otrzymaliśmy Państwa zamówienie.<br />
            Na podany adres e-mail wysłaliśmy potwierdzenie. Dziękujemy!<br /><br />
            Zamówienie będzie obsługiwane przez Centrum Rezerwacji
            Travelplanet.pl S.A.
          </p>
          <a href="/" title="Powrót do strony głównej">strona główna</a>
        </div>
      </div>
    </a-layout-content>
  </div>
</template>

<script>
import * as CONFIG from "./config.js";
import T1Breadcrumbs from "./T1Breadcrumbs/T1Breadcrumbs";

export default {
  name: "t1content",
  data: () => ({
    numerzamowienia: "",
    data: "",
    tourop: "",
    price: "",
    country: CONFIG.panstwo_nazwapl
  }),
  methods: {
    getBreadcrumbs() {
      let crumbsArr = [];
      crumbsArr.push({ name: "Potwierdzenie rezerwacji", link: "" });
      return crumbsArr;
    }
  },
  mounted() {
    this.numerzamowienia = this.$route.query.res;
    this.data = this.$route.query.data;
    this.tourop = this.$route.query.tourop;
    this.price = this.$route.query.price;
    console.log(this.numerzamowienia);
    console.log(this.data);
    console.log(this.tourop);
    console.log(this.price);
    console.log(this.country);
    sendGTM(
      this.numerzamowienia,
      this.data,
      this.country,
      this.price,
      this.tourop
    );
  },
  components: {
    T1Breadcrumbs
  }
};

function sendGTM(transactionID, data, country, price, tourOp) {
  var tripDate = Date.parse(data);
  var todayDate = new Date().getTime();
  var diffDate = tripDate - todayDate;

  var numMonths = diffDate / 2628000000;
  var numDays = diffDate / 86400000;

  var sku = "";
  if (numMonths >= 1 && numMonths < 2) {
    sku = "1-2 m-ce";
  } else if (numDays <= 10) {
    sku = "<=10 dni";
  } else if (numDays >= 11 && numDays <= 21) {
    sku = "11-21 dni";
  } else if (numDays >= 22 && numDays <= 30) {
    sku = "22-30 dni";
  } else {
    sku = ">2 m-cy";
  }

  var trID = "'" + transactionID + "'";
  var name = "'" + country + "'";
  var gaPrice = "'" + price + "'";
  var tOp = "'" + tourOp + "'";

  dataLayer.push({
    transactionId: trID,
    transactionAffiliation: "",
    transactionTotal: gaPrice,
    transactionShipping: 0,
    transactionTax: 0,
    transactionProducts: [
      {
        name: name,
        sku: sku,
        category: tOp,
        price: gaPrice,
        quantity: 1
      }
    ]
  });
}
</script>

<style lang="scss" scoped>
@import "@/scss/_partials/_confirm-box";
</style>
